export default __webpack_public_path__ + "static/media/global.ca3ced68.png";